import { useState, useCallback } from 'react';

export default () => {
  const [avatars, setAvatars] = useState<API.Avatar[]>([]);
  const [selectedAvatar, setSelectedAvatar] = useState<API.Avatar | null>(null);
  const [currentRoom, setCurrentRoom] = useState<string>('main');

  const updateAvatar = useCallback((avatarId: string, updates: Partial<API.Avatar>) => {
    setAvatars((prev) =>
      prev.map((avatar) => (avatar.id === avatarId ? { ...avatar, ...updates } : avatar)),
    );
    if (selectedAvatar?.id === avatarId) {
      setSelectedAvatar((prev) => (prev ? { ...prev, ...updates } : null));
    }
  }, [selectedAvatar]);

  const updateAvatarPosition = useCallback((avatarId: string, position: { x: number; y: number; z: number }) => {
    updateAvatar(avatarId, { position });
  }, [updateAvatar]);

  const addAvatar = useCallback((avatar: API.Avatar) => {
    setAvatars((prev) => [...prev, avatar]);
  }, []);

  const removeAvatar = useCallback((avatarId: string) => {
    setAvatars((prev) => prev.filter((avatar) => avatar.id !== avatarId));
    if (selectedAvatar?.id === avatarId) {
      setSelectedAvatar(null);
    }
  }, [selectedAvatar]);

  return {
    avatars,
    selectedAvatar,
    currentRoom,
    setAvatars,
    setSelectedAvatar,
    setCurrentRoom,
    updateAvatar,
    updateAvatarPosition,
    addAvatar,
    removeAvatar,
  };
};

